export const hasRateLimitMessage = (error) => {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' && detail.toLowerCase().includes('rate limit');
};

export const shouldSuppressRateLimit = (error) => hasRateLimitMessage(error);
